import { render, staticRenderFns } from "./CardweekendPhone.vue?vue&type=template&id=114fe145&"
import script from "./CardweekendPhone.vue?vue&type=script&lang=js&"
export * from "./CardweekendPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports